import firebase from 'firebase'

const firebaseConfig = {
  apiKey: "AIzaSyCw5p3lqP2jDehS8rhXhn_ZkYJFFh3OI1k",
  authDomain: "pedido-rapido-app.firebaseapp.com",
  databaseURL: "https://pedido-rapido-app.firebaseio.com",
  projectId: "pedido-rapido-app",
  storageBucket: "pedido-rapido-app.appspot.com",
  messagingSenderId: "846966783826",
  appId: '1:846966783826:web:50b44ae201ad1287',
}

export const app = firebase.initializeApp(firebaseConfig)

export default firebase